import { render, staticRenderFns } from "./AlertTooltip.vue?vue&type=template&id=4cf96d3c"
import script from "./AlertTooltip.vue?vue&type=script&lang=js"
export * from "./AlertTooltip.vue?vue&type=script&lang=js"
import style0 from "./AlertTooltip.vue?vue&type=style&index=0&id=4cf96d3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports